import { initializeBrowserPulse, PulseSdk } from '@pulse/typescript';
import { PulseProvider } from '@pulse/react';
import { ComponentType } from 'react';

const remoteSettings = {
  app: 'picsart.com',
  sdks: ['settings', 'tracker'] as PulseSdk[],
  config: {},
};

const { settings } = initializeBrowserPulse(remoteSettings);

export const getRemoteSettings = settings.get;

function withPulse<T>(Component: ComponentType<T>) {
  return function HOC(props: T) {
    return (
      <PulseProvider {...remoteSettings}>
        <Component {...props} />
      </PulseProvider>
    );
  };
}

export default withPulse;
